import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_PLAYERS_BONUSES_ADDITIONAL_ROUTE_NAME,
  ADMIN_PLAYERS_BONUSES_LIST_ROUTE_NAME,
  PLAYERS_BONUSES_PERMISSIONS,
  TRANSLATION_ADMIN_PLAYERS_BONUSES,
} from '@modules/players-bonuses/constants';
import { PlayersBonusesCreateModule } from '@modules/players-bonuses/submodules/create/PlayerBonusesCreateModule';
import { PlayerBonusesEditModule } from '@modules/players-bonuses/submodules/edit/PlayerBonusesEditModule';
import { getTranslationKeys } from '@modules/players-bonuses/translations';
import {
  ADMIN_PLAYERS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

export class PlayersBonusesModule extends AppModule {
  protected submodules = [
    new PlayersBonusesCreateModule(),
    new PlayerBonusesEditModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    // Players bonuses
    router.addAdminRoute({
      name: ADMIN_PLAYERS_BONUSES_ADDITIONAL_ROUTE_NAME,
      path: 'bonuses',
      permission: PLAYERS_BONUSES_PERMISSIONS.PLAYERS_BONUSES_SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'PlayersBonusesListPage',
    });

    router.addChildRoute(ADMIN_PLAYERS_BONUSES_ADDITIONAL_ROUTE_NAME, {
      name: ADMIN_PLAYERS_BONUSES_LIST_ROUTE_NAME,
      path: '',
      permission: PLAYERS_BONUSES_PERMISSIONS.PLAYERS_BONUSES_SHOW,
      component: () => import('@modules/players-bonuses/pages/PlayersBonusesListPage/PlayersBonusesListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PLAYERS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PLAYERS_BONUSES'),
      to: {
        name: ADMIN_PLAYERS_BONUSES_LIST_ROUTE_NAME,
      },
      permission: PLAYERS_BONUSES_PERMISSIONS.PLAYERS_BONUSES_SHOW,
      id: ADMIN_PLAYERS_BONUSES_LIST_ROUTE_NAME,
      order: 30,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_ADMIN_PLAYERS_BONUSES, getTranslationKeys);
  }
}
